import { useScroll, useVelocity, useSpring, useTransform, useReducedMotion } from "framer-motion";

// Skews an element against the current scroll velocity so cards lean into
// the motion and settle upright when scrolling stops — ties the DOM to the
// same "driven by scroll" physics as the background video scrub.
export function useVelocitySkew(maxDeg = 1.5) {
  const reduced = useReducedMotion();
  const { scrollY } = useScroll();
  const velocity = useVelocity(scrollY);
  const smoothed = useSpring(velocity, { damping: 50, stiffness: 400 });
  const skew = useTransform(smoothed, [-1500, 1500], [maxDeg, -maxDeg], { clamp: true });
  return reduced ? 0 : skew;
}
